<template>
  <div class="comp-xl-user-depart">
    <xl-tree-member-modal ref="treeMemberModalRef" :tree="tree" @cb="getValUser($event, index, i)" :isScreen="isScreen" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :depart="sub.departList" :user="sub.userList">
      <div class="screen-box">
        <jw-select :loading="data.loading" placeholder="请输入..." class="rule-form-item-sub-select sub-select-userdept" @change="change" v-model="sub.userDeptIds" :multiple="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :max-tag-count="maxTagCount" style="width: calc(100% - 30px)" :trigger-props="{ updateAtScroll: true, contentClass: 'search-ultra-filter-select' }" allow-search allow-clear :filter-option="false" @input-value-change="search">
          <template #label="{ data }">
            <ly-show-filters showType="condition" :showInner="data.label" />
          </template>
          <jw-option v-for="item in data.list" :key="item.id" :title="item.userName || item.departmentName" :value="item.id">
            <template v-if="!isdepart">
              <template v-if="isAvatar">
                <xl-avatar style="pointer-events: none" :avatar="{ name: item.userName || item.departmentName, url: item.avatar || item.avatarOrigin, id: item.id || item.userId }" :size="22" />
              </template>
              <template v-else>
                {{ item.userName || item.departmentName }}
              </template>
            </template>
            <template v-else>
              {{ item.departmentName }}
            </template>
          </jw-option>
        </jw-select>
        <jw-button @click="openTreeMemberModalRef">
          <template #icon>
            <icon-plus />
          </template>
        </jw-button>
      </div>
    </xl-tree-member-modal>
  </div>
</template>

<script setup>
import { orgService } from '@/api';
import { onMounted } from 'vue';
import { computed, reactive, ref, watch } from 'vue';
const props = defineProps({
  // sub.operation  单选 多选
  sub: {
    type: Object,
    default: () => {
      return {};
    }
  },
  isScreen: {
    type: Boolean,
    default: false
  },
  // 是否展示头像
  isAvatar: {
    type: Boolean,
    default: false
  },
  maxTagCount: {
    type: [Number, String],
    default: 1
  },
  tree: {
    //组织架构树
    require: true,
    type: Object,
    default: () => {
      return {
        data: []
      };
    }
  }
});
const isdepart = computed(() => props.tree.checkDepartment);
const operation = computed(() => props.sub.operation);

// 响应式变量，用来标记当前屏幕宽度是否小于 1440px

const emits = defineEmits(['cb']);
const treeMemberModalRef = ref();
const sub = computed(() => props.sub);
console.log('sub', sub.value);
const data = reactive({
  loading: false,
  list: sub.value.userList || sub.value.departList || []
});
const openTreeMemberModalRef = () => {
  treeMemberModalRef.value.openDialog();
};

onMounted(() => {
  if (sub.value.userList && sub.value.userList?.length) {
    data.list = sub.value.userList;
  }
  if (sub.value.departList && sub.value.departList?.length) data.list = sub.value.departList;
});

let timer;
const search = (e) => {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    if (e.trim()) getUserAndDeptByKeyWord(e);
  }, 500);
};
// 搜索部门/人员
const getUserAndDeptByKeyWord = async (e) => {
  const params = {
    departmentId: '',
    all: false,
    keyWord: e || '',
    userSelector: true
  };
  data.loading = true;
  const json = await orgService.searchDepartUserList(params);
  if (!json.error) {
    if (isdepart.value) {
      data.list = (json.result?.deptList || []).concat(data.list)?.map((v) => {
        return {
          ...v,
          id: Number(v.id)
        };
      });
      setName();
    } else {
      console.log('subInfo', data.list, json.result?.userList, sub.value.userDeptIds);
      const lastList = data.list.filter((fItem) => sub.value.userDeptIds?.includes(fItem.id));
      data.list = (json.result?.userList || []).concat(lastList);
      // data.list = json.result?.userList || [];
    }
    data.list = uniqueById(data.list);
  }
  data.loading = false;
};

const change = (v) => {
  console.log('change-aa', v);
  let arr;
  if (Array.isArray(v)) {
    arr = v;
  } else {
    arr = [v];
  }
  if (arr && arr.length) {
    const _Array = [];
    arr.forEach((el) => {
      const obj = data.list.filter((item) => item.id == el);
      if (obj && obj.length) _Array.push(obj[0]);
    });
    if (isdepart.value) {
      sub.value.departList = _Array?.map((item) => {
        return {
          id: item.id,
          departmentName: item.departmentName,
          name: item.departmentName
        };
      });
      setName();
    } else {
      sub.value.userList = _Array?.map((item) => {
        return {
          avatar: item.avatar || item.avatarOrigin,
          avatarOrigin: item.avatar || item.avatarOrigin,
          id: item.id || item.userId,
          name: item.name || item.userName,
          userName: item.name || item.userName
        };
      });
    }
    // emits('cb', { departList: sub.value?.departList || [], userList: sub.value?.userList || [] });
  } else {
    sub.value.userList = [];
    sub.value.departList = [];
  }
  emits('cb', { departList: sub.value?.departList || [], userList: sub.value?.userList || [] });
};
const getValUser = (v) => {
  console.log('getValUser-v', v);
  const Array = v?.userList.length ? v?.userList : v?.departList.length ? v?.departList : [];
  data.list = data.list.concat(Array);
  data.list = uniqueById(data.list);
  sub.value.userDeptIds = Array?.map((u) => u.id);
  setName();
  emits('cb', v);
};
// const colors = ['#f53f3f', '#7816ff', '#00b42a', '#165dff', '#ff7d00', '#eb0aa4', '#7bc616', '#ffb400', '#b71de8', '#0fc6c2'];
// const color = (id) => {
//   let getId = id;
//   getId = getId + '';
//   const i = getId.substr(-1, 1);
//   return colors[i];
// };

const setName = () => {
  if (isdepart.value) {
    data.list?.forEach((item) => {
      if (item.departmentName) item.name = item.departmentName;
    });
  }
};

const uniqueById = (arr) => {
  const uniqueMap = {};
  return arr.filter((obj) => {
    if (!uniqueMap[obj.id]) {
      uniqueMap[obj.id] = true;
      return true;
    }
    return false;
  });
};
setName();

watch(
  () => operation.value,
  (v, o) => {
    console.log('watch', v, o);
    data.list = [];
  },
  {
    deep: true
  }
);
</script>
<style scoped lang="less">
@import './xl-user-depart.less';
</style>
